import type { CollectionReceipt, LateFeeApplication } from "../services/types";

/**
 * Collection mock data (Phase 4). Receipts reference demands derived from the
 * groups' closed cycles, so every paid/partial/paid state is internally
 * consistent with Phase 2 & 3. The amounts below match each cycle's net
 * installment (installment minus per-member dividend). One receipt is reversed
 * to demonstrate that receipts are never deleted, only reversed. All figures
 * are illustrative demo data — real figures come from the backend.
 */
export const MOCK_COLLECTION_RECEIPTS: CollectionReceipt[] = [
  {
    id: "rcpt-001", receiptNumber: "RCP-20260821-001", memberId: "m1",
    payments: [{ demandId: "g1-c6-m1", amount: 9643 }], total: 9643,
    mode: "cash", reference: "", receivedOn: "2026-08-21T10:05:00.000Z", remarks: "",
    collectedBy: "Anita Desai", createdAt: "2026-08-21T10:05:00.000Z",
  },
  {
    id: "rcpt-002", receiptNumber: "RCP-20260821-002", memberId: "m8",
    payments: [{ demandId: "g1-c6-m8", amount: 9643 }], total: 9643,
    mode: "upi", reference: "upi@ybl 87531", receivedOn: "2026-08-21T11:20:00.000Z", remarks: "",
    collectedBy: "Suresh Kumar", createdAt: "2026-08-21T11:20:00.000Z",
  },
  {
    id: "rcpt-003", receiptNumber: "RCP-20260821-003", memberId: "m2",
    payments: [{ demandId: "g3-c8-m2", amount: 19300 }], total: 19300,
    mode: "bank_transfer", reference: "NEFT 40211834", receivedOn: "2026-08-21T14:40:00.000Z", remarks: "",
    collectedBy: "Priya Sharma", createdAt: "2026-08-21T14:40:00.000Z",
  },
  {
    id: "rcpt-004", receiptNumber: "RCP-20260822-004", memberId: "m9",
    payments: [{ demandId: "g3-c8-m9", amount: 19300 }], total: 19300,
    mode: "cash", reference: "", receivedOn: "2026-08-22T09:45:00.000Z", remarks: "",
    collectedBy: "Anita Desai", createdAt: "2026-08-22T09:45:00.000Z",
  },
  {
    id: "rcpt-005", receiptNumber: "RCP-20260822-005", memberId: "m4",
    payments: [{ demandId: "g7-c3-m4", amount: 24334 }], total: 24334,
    mode: "cash", reference: "", receivedOn: "2026-08-22T10:30:00.000Z", remarks: "",
    collectedBy: "Suresh Kumar", createdAt: "2026-08-22T10:30:00.000Z",
  },
  {
    id: "rcpt-006", receiptNumber: "RCP-20260822-006", memberId: "m3",
    payments: [{ demandId: "g8-c3-m3", amount: 14445 }], total: 14445,
    mode: "upi", reference: "upi 99123", receivedOn: "2026-08-22T12:15:00.000Z", remarks: "",
    collectedBy: "Priya Sharma", createdAt: "2026-08-22T12:15:00.000Z",
  },
  {
    id: "rcpt-007", receiptNumber: "RCP-20260823-007", memberId: "m4",
    payments: [{ demandId: "g14-c1-m4", amount: 9500 }], total: 9500,
    mode: "cash", reference: "", receivedOn: "2026-08-23T09:10:00.000Z", remarks: "",
    collectedBy: "Anita Desai", createdAt: "2026-08-23T09:10:00.000Z",
  },
  {
    id: "rcpt-008", receiptNumber: "RCP-20260823-008", memberId: "m10",
    payments: [{ demandId: "g2-c4-m10", amount: 4778 }], total: 4778,
    mode: "cheque", reference: "CHQ 004521", receivedOn: "2026-08-23T11:05:00.000Z", remarks: "",
    collectedBy: "Suresh Kumar", createdAt: "2026-08-23T11:05:00.000Z",
  },
  {
    id: "rcpt-009", receiptNumber: "RCP-20260824-009", memberId: "m15",
    payments: [{ demandId: "g1-c6-m15", amount: 5000 }], total: 5000,
    mode: "cash", reference: "", receivedOn: "2026-08-24T10:20:00.000Z", remarks: "Partial — balance next week",
    collectedBy: "Priya Sharma", createdAt: "2026-08-24T10:20:00.000Z",
  },
  {
    id: "rcpt-010", receiptNumber: "RCP-20260824-010", memberId: "m16",
    payments: [{ demandId: "g7-c3-m16", amount: 24334 }], total: 24334,
    mode: "upi", reference: "upi 55432", receivedOn: "2026-08-24T12:50:00.000Z", remarks: "",
    collectedBy: "Anita Desai", createdAt: "2026-08-24T12:50:00.000Z",
  },
  {
    id: "rcpt-011", receiptNumber: "RCP-20260824-011", memberId: "m28",
    payments: [{ demandId: "g14-c1-m28", amount: 9500 }], total: 9500,
    mode: "cash", reference: "", receivedOn: "2026-08-24T15:00:00.000Z", remarks: "",
    collectedBy: "Suresh Kumar", createdAt: "2026-08-24T15:00:00.000Z",
  },
  {
    id: "rcpt-012", receiptNumber: "RCP-20260825-012", memberId: "m13",
    payments: [{ demandId: "g3-c8-m13", amount: 19300 }], total: 19300,
    mode: "bank_transfer", reference: "NEFT 50218344", receivedOn: "2026-08-25T09:30:00.000Z", remarks: "",
    collectedBy: "Priya Sharma", createdAt: "2026-08-25T09:30:00.000Z",
  },
  {
    id: "rcpt-013", receiptNumber: "RCP-20260825-013", memberId: "m19",
    payments: [{ demandId: "g8-c3-m19", amount: 14445 }], total: 14445,
    mode: "cash", reference: "", receivedOn: "2026-08-25T10:45:00.000Z", remarks: "",
    collectedBy: "Anita Desai", createdAt: "2026-08-25T10:45:00.000Z",
  },
  {
    id: "rcpt-014", receiptNumber: "RCP-20260825-014", memberId: "m1",
    payments: [{ demandId: "g2-c4-m1", amount: 4778 }], total: 4778,
    mode: "upi", reference: "upi 76543", receivedOn: "2026-08-25T11:10:00.000Z", remarks: "",
    collectedBy: "Suresh Kumar", createdAt: "2026-08-25T11:10:00.000Z",
  },
  {
    id: "rcpt-015", receiptNumber: "RCP-20260825-015", memberId: "m4",
    payments: [{ demandId: "g1-c6-m4", amount: 9643 }], total: 9643,
    mode: "cash", reference: "", receivedOn: "2026-08-25T12:05:00.000Z", remarks: "",
    collectedBy: "Anita Desai", createdAt: "2026-08-25T12:05:00.000Z",
  },
  // Reversed — demonstrates receipts are never deleted, only reversed.
  {
    id: "rcpt-016", receiptNumber: "RCP-20260822-016", memberId: "m12",
    payments: [{ demandId: "g1-c6-m12", amount: 9643 }], total: 9643,
    mode: "cash", reference: "", receivedOn: "2026-08-22T13:25:00.000Z", remarks: "",
    collectedBy: "Priya Sharma", createdAt: "2026-08-22T13:25:00.000Z",
    reversedAt: "2026-08-24T09:00:00.000Z", reversedBy: "Anita Desai",
    reversalReason: "Duplicate receipt issued; member paid separately.",
  },
];

/** A late fee already applied to an overdue demand in g3 (flat fee, cycle 8). */
export const MOCK_LATE_FEE_APPLICATIONS: LateFeeApplication[] = [
  {
    id: "lfe-001",
    demandId: "g3-c8-m17",
    amount: 200,
    reason: "Arrears from cycle 8; fee per group policy.",
    appliedBy: "Anita Desai",
    appliedAt: "2026-08-25T09:15:00.000Z",
  },
  {
    id: "lfe-002",
    demandId: "g7-c3-m41",
    amount: 0,
    reason: "Waived — genuine hardship.",
    appliedBy: "Anita Desai",
    appliedAt: "2026-08-25T09:20:00.000Z",
    waivedAt: "2026-08-25T09:22:00.000Z",
    waivedBy: "Anita Desai",
    waiveReason: "Member requested waiver after a medical emergency.",
  },
];